import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { I18n } from "aws-amplify/utils";
import React, { useEffect, useState } from "react";

const DeleteSimulationModal = ({
  open,
  onClose,
  selectedSimulation,
  onSubmit,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDialog-paper": {
          width: "90%",
          maxWidth: "none",
          borderRadius: "1rem",
        },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <DialogTitle sx={{ fontSize: "24px" }} color="error" align="center">
        {I18n.get("Delete simulation")}
      </DialogTitle>
      <DialogContent>
        {I18n.get("Are you sure you want to delete this simulation?")}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          {I18n.get("Close")}
        </Button>
        <Button
          onClick={onSubmit}
          variant="contained"
          sx={{
            backgroundColor: "#344767",
            color: "rgb(255, 255, 255)",
            "&:hover": {
              backgroundColor: "rgb(40, 55, 80)",
            },
            "&:focus:not(:hover)": {
              backgroundColor: "#344767",
              boxShadow: "none",
            },
          }}
        >
          {I18n.get("Delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default DeleteSimulationModal;
